import { render } from "./DemandAddress.component.vue?vue&type=template&id=fd52c35c&scoped=true"
import script from "./DemandAddress.component.vue?vue&type=script&lang=js"
export * from "./DemandAddress.component.vue?vue&type=script&lang=js"

import "./DemandAddress.component.vue?vue&type=style&index=0&id=fd52c35c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd52c35c"]])

export default __exports__